import { render, staticRenderFns } from "./publicUsers.vue?vue&type=template&id=fa70848a&"
import script from "./publicUsers.vue?vue&type=script&lang=js&"
export * from "./publicUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports